<template>
  <div class="white-section mt-2 box-info">

    <permission-units-repeater :v="$v"></permission-units-repeater>
    <div class="d-flex justify-content-end mb-2">
      <b-button
          @click="updateUser"
          variant="primary"
          size="sm"
      >{{ $t("general.submit") }}
      </b-button
      >
    </div>
  </div>
</template>

<script>
import PermissionUnitsRepeater from "@/components/permissions/PermissionUnitsRepeater";
import {mapGetters} from "vuex";
import {
  BButton,
} from "bootstrap-vue";
import {required, requiredIf} from "vuelidate/lib/validators";
export default {
  components: {PermissionUnitsRepeater, BButton},
  created(){
    this.$store.commit('permissions/RESET_PERMISSION_UNITS')
    this.searchUnits();
    this.getPermissionUnits();
    if (!this.userToEdit) {
      // console.log('!this.userToEdit')
      this.$store.dispatch('user/findUser', this.$route.params.userId).then((res) => {
        this.pushBreadcrumb({text: 'permissionUnits', to: {name: 'addPermissions'}, translate: true});
        this.pushBreadcrumb({text: res.firstName + ' ' + res.lastName, translate: false});
        this.setCurrentBreadcrumb([{
          text: 'permissionUnits',
          to: {name: 'addPermissions'},
          translate: true
        }, {text: res.firstName + ' ' + res.lastName, translate: false}]);
        this.$store.commit("user/SET_USER_TO_EDIT", res);
        this.userToEdit.permissionUnits.length ? this.userPermissionUnits = this.userToEdit.permissionUnits : this.userPermissionUnits = [{unitId: null, permissionUnitId: null}]
      })
    }else{
      // console.log('else !this.userToEdit')
      this.userToEdit.permissionUnits.length ? this.userPermissionUnits = this.userToEdit.permissionUnits : this.userPermissionUnits = [{unitId: null, permissionUnitId: null}]
 this.pushBreadcrumb({text: 'permissionUnits', to: {name: 'addPermissions'}, translate: true});
        this.pushBreadcrumb({text: this.userToEdit.firstName + ' ' + this.userToEdit.lastName, translate: false});
        this.setCurrentBreadcrumb([{
          text: 'permissionUnits',
          to: {name: 'addPermissions'},
          translate: true
        }, {text: this.userToEdit.firstName + ' ' + this.userToEdit.lastName, translate: false}]);
    }
    // console.log(this.userPermissionUnits)
  },
  validations() {
    return {
      userPermissionUnits: {
        $each: {
          unitId: {
            required: requiredIf(() => {
              if(this.userPermissionUnits.length > 1) {
                return true
              }else{
                return false
              }

            }),
          },
          permissionUnitId: {
            required: requiredIf(() => {
              if(this.userPermissionUnits.length > 1) {
                return true
              }else{
                return false
              }

            }),
          }
        }
      }
    }
  },
  computed:{
    ...mapGetters({
      userToEdit: 'user/userToEdit'
    }),
    userPermissionUnits: {
      set(userPermissionUnits) {
        this.$store.commit("permissions/SET_USER_PERMISSION_UNITS", userPermissionUnits);
      },
      get() {
        return this.$store.getters["permissions/userPermissionUnits"];
      },
    },
  },
  methods:{
    searchUnits(){
      this.$store.dispatch('units/searchUnitForCurrentUser', {status:'active'}).then(() => {

      })
    },
    getPermissionUnits(){
      this.$store.dispatch('permissionUnits/getActivePermissionUnits').then(() => {

      })
    },
    updateUser(){
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // console.log(this.userPermissionUnits)
        let payload = []
        if (this.userPermissionUnits.length) {
          this.userPermissionUnits.forEach(item => {
            payload.push(_.omitBy(item, (v) => _.isUndefined(v) || _.isNull(v) || v === ''))
          })
          payload = payload.map((userPermissionUnit)=>{
            return _.omitBy(userPermissionUnit, (v) => _.isUndefined(v) || _.isNull(v) || v === '' || _.isEmpty(v) );
          })
          payload = payload.filter((obj)=>{
            return !_.isEmpty(obj)
          })
          // payload = _.omitBy(this.userPermissionUnits, (v) => _.isUndefined(v) || _.isNull(v) || v === '')
        }
        this.$store.dispatch('user/editUser', {permissionUnits: payload}).then((res) => {
          this.$root.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
            // title: this.$t('toastification.success'),
            variant: 'success',
            solid: true,
          });
          this.$store.commit('permissions/RESET_PERMISSION_UNITS');
          // this.$router.push({name:'manageUsers'})
          this.$router.push({name:'assignPermission',params:{userId: this.$route.params.userId}})

        })
      }
    }
  }
}
</script>